import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { TenantFilter } from "../types/TenantFilter";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetch = (authHeader: string) => () =>
  axios.get<TenantFilter>(`${env.verifyServiceUrl}common/tenant/filter`, {
    headers: {
      Authorization: authHeader,
    },
  });

export const useTenantFilter = () => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["tenantFilter"], fetch(authHeader), {
    retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    }
  });
};
